import requset from "utils/request";
import { WRITE} from "apiurl/index.js";
import baseURL from "apiurl/env.js"
// 推广精彩内容
export function extensionDetail(msg, action) {
  return requset({
    url: `${baseURL.novelapi}/book/log/request?msg=${msg}&action=${action}`,
    headers:{"lang":"zh_TW", "client-platform":2},
    method: "GET",
    msg: 0,
  });
}
